import { P, Span } from '@workramp/ui';
import styled from 'styled-components';

export const StyledP = styled(P)`
  display: flex;
  flex-wrap: wrap;
  column-gap: 4px;
  align-items: center;
  color: ${({ theme }) => theme.colors.on[700]};
`;

export const StyledHighlightSpan = styled(Span)`
  display: inline-block;

  em {
    font-style: normal;
    background-color: ${({ theme }) => theme.colors.primary[100]};
  }
`;
